const T_PREFIX = "auth";

export const resetPasswordPopupTrns = {
  title: `${T_PREFIX}.reset-password-popup.title`,
  description: `${T_PREFIX}.reset-password-popup.description`,
  sendInstructionsButton: `${T_PREFIX}.reset-password-popup.send-instructions-btn`,
};
